import { useEffect, useState } from 'react';
import { Keyboard, LayoutAnimation } from 'react-native';
import { checkIsPlatform } from '../utils';
export var useKeyboard = () => {
  var _a, _b;
  var _useState = useState(false),
    keyboardVisible = _useState[0],
    setKeyboardVisible = _useState[1];
  var _useState2 = useState(0),
    keyboardHeight = _useState2[0],
    setKeyboardHeight = _useState2[1];
  var SafeAreaContext;
  if (!checkIsPlatform('web')) {
    
  }
  var insets = SafeAreaContext === null || SafeAreaContext === void 0 ? void 0 : SafeAreaContext.useSafeAreaInsets();
  useEffect(() => {
    var showSubscription = Keyboard.addListener('keyboardDidShow', e => {
      var _a;
      LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
      setKeyboardVisible(true);
      setKeyboardHeight((_a = e === null || e === void 0 ? void 0 : e.endCoordinates) === null || _a === void 0 ? void 0 : _a.height);
    });
    var hideSubscription = Keyboard.addListener('keyboardDidHide', () => {
      setKeyboardVisible(false);
      LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
      setKeyboardHeight(0);
    });
    return () => {
      showSubscription.remove();
      hideSubscription.remove();
    };
  }, []);
  return {
    keyboardVisible,
    keyboardHeight,
    top: (_a = insets === null || insets === void 0 ? void 0 : insets.top) !== null && _a !== void 0 ? _a : 0,
    bottom: (_b = insets === null || insets === void 0 ? void 0 : insets.bottom) !== null && _b !== void 0 ? _b : 0
  };
};